import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

const getCommentHistories = async () => {
  const token = getToken();
  if (token) {
    try {
      const response = await fetch(`${BASE_URL}/api/comment_histories`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.status === 200) {
        const data = await response.json();
        return data.comment_histories;
      } else {
        return null;
      }
    } catch {
      return null; // network error
    }
  } else {
    return null; // No token
  }
};

export default getCommentHistories;
